module.exports = __webpack_public_path__ + "assets/img/dice.69ea3c5b.png";